export function DisputeNotification({
  resolutionStatus,
  onShowDisputeDetails,
  logCode,
}) {
  return (
    <div className="p-col-12">
      <div className={`info-card ${resolutionStatus?.toLowerCase()}`}>
        <div>
          <span className="info-card-text">
            Cancellation Status: <b> {resolutionStatus}</b>
          </span>
        </div>
        <div className="">
          <span className="info-card-text">
            Log Code:{" "}
            <button className="bare-button" onClick={onShowDisputeDetails}>
              {logCode}
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}
